export default __webpack_public_path__ + "static/media/img--design-1.4188cbca.jpg";